import React from 'react';
import khurram from '../../assets/images/khurram_pro.jpg';
import Mohsin from '../../assets/images/raja_mohsin.jpg';
import kaleem from '../../assets/images/sardar_kaleem.jpg';
import ibrahim from '../../assets/images/ch_ibrahim.jpg';

const teamMembers = [
    {
        name: 'Ch Khurram Shahzad',
        position: 'Senior Partner and Advocate',
        image: khurram,
        specialization: 'Criminal Law and Family Law',
    },
    {
        name: 'Raja Mohsin Minhas',
        position: 'Senior Advocate',
        image: Mohsin,
        specialization: 'Criminal Law',
    },
    {
        name: 'Ch Ibrahim Jahangir',
        position: 'Senior Advisor',
        image: ibrahim,
        specialization: 'Corporate Law',
    },
    {
        name: 'Sardar Kaleem Ullah Khan',
        position: 'Senior Associate',
        image: kaleem,
        specialization: 'Civil Law',
    },
];

const TeamSection = () => {
    return (
        <section className="py-20 bg-gradient-to-b from-white to-gray-50">
            <div className="container mx-auto px-4">
                <div className="mb-16">
                    <div className="inline-block bg-indigo-100 text-indigo-800 px-4 py-1 rounded-md text-sm font-medium mb-4">
                        OUR EXPERT ATTORNEYS
                    </div>
                    <h2 className="text-4xl font-bold mb-4">Our Legal Team</h2>
                    <p className="text-gray-600 max-w-2xl">
                        Meet our team of experienced lawyers dedicated to providing you with 
                        the highest quality legal services.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                    {teamMembers.map((member, index) => (
                        <div 
                            key={index} 
                            className="group bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2"
                        >
                            <div className="relative overflow-hidden">
                                <div className="absolute top-0 left-0 w-full h-full bg-indigo-900 opacity-0 group-hover:opacity-20 transition-opacity duration-300 z-10"></div>
                                <img 
                                    src={member.image} 
                                    alt={member.name} 
                                    className="w-full h-80 object-cover object-center transition-transform duration-500 group-hover:scale-105"
                                />
                                <div className="absolute top-4 right-4 bg-indigo-600 text-white text-xs font-bold uppercase tracking-wider py-1 px-3 rounded-full">
                                    {member.specialization}
                                </div>
                            </div>
                            <div className="p-6 border-t border-gray-100">
                                <h3 className="text-xl font-bold mb-1 text-gray-800">{member.name}</h3>
                                <p className="text-indigo-600 font-medium mb-3">{member.position}</p>
                                <div className="h-1 w-12 bg-indigo-600 rounded-full"></div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default TeamSection;